// TODO: We should get rid of this eventually (a few months?) because we no longer track user views via localstorage

import axios from 'axios';
import EzUser from 'init/init-user';

if (EzUser.signedIn && localStorage.getItem('resource_user_views') !== null) {
  // TODO: Be sure to localize this string once we localize this route
  if (window.location.href.indexOf('/account/dashboard') !== -1) {
    var realTime = true; // eslint-disable-line vars-on-top, no-var, block-scoped-var
  } else {
    var realTime = false; // eslint-disable-line vars-on-top, no-var, block-scoped-var, no-redeclare
  }

  const viewsData = {
    views: encodeURIComponent(localStorage.getItem('resource_user_views')),
    realtime: realTime, // eslint-disable-line block-scoped-var
  };

  const csrfToken = document.querySelector('meta[name=csrf-token]').content;
  axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;

  axios.post('/api/v1/resource-user-views/import', viewsData)
    .then(() => {
      localStorage.removeItem('resource_user_views');
      // eslint-disable-next-line block-scoped-var
      if (realTime) {
        location.reload(); // eslint-disable-line no-restricted-globals
      }
    });
}
